import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=0319763d&scoped=true&"
import script from "./FansList.vue?vue&type=script&lang=js&"
export * from "./FansList.vue?vue&type=script&lang=js&"
import style0 from "./FansList.vue?vue&type=style&index=0&id=0319763d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319763d",
  null
  
)

export default component.exports